import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import TransactionHome from "./TransactionHome";
import { useTranslation } from "react-i18next";

export default function TransactionList() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("List of Transactions")} parent={t("Home")} title={t("List of Transactions")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                       <TransactionHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
